// @ts-nocheck
/* eslint-disable */

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.BaseTheme = void 0;

var _colors = require('./colors.theme');

var _controls = require('./controls.theme');

var _breakpoints = require('./breakpoints.theme');

var _typography = require('./typography.theme');

var _graphs = require('./graphs.theme');

function _objectSpread(target) {
  function isEnumerable(sym, src) {
    return Object.getOwnPropertyDescriptor(src, sym).enumerable;
  }
  function symbolFilterFactory(src) {
    return function (sym) {
      return isEnumerable(sym, src);
    };
  }
  function defineKey(target, source) {
    return function (key) {
      _defineProperty(target, key, source[key]);
    };
  }
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(symbolFilterFactory(source)));
    }
    ownKeys.forEach(defineKey(target, source));
  }
  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}

var BaseTheme = _objectSpread(
  {
    name: 'BaseTheme',
    dark: false,
    colors: _objectSpread({}, _colors.colors, {
      primaryFontDisabledOpacity: 0.3
    })
  },
  _controls.controls,
  {
    breakpoints: _objectSpread({}, _breakpoints.breakpoints),
    typography: _objectSpread({}, _typography.typography),
    graphs: _objectSpread({}, _graphs.graphs),
    defaultFontFamily: "'Overpass', sans-serif",
    containerMaxWidth: '1080px'
  }
);

exports.BaseTheme = BaseTheme;
